import { render, staticRenderFns } from "./DataTableRow.vue?vue&type=template&id=5961e4f5&scoped=true&"
import script from "./DataTableRow.vue?vue&type=script&lang=js&"
export * from "./DataTableRow.vue?vue&type=script&lang=js&"
import style0 from "./DataTableRow.vue?vue&type=style&index=0&id=5961e4f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961e4f5",
  null
  
)

export default component.exports